// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__h20Qu","alertIcon":"ConfirmModal_alertIcon__Qt8b9"};